import React from 'react';

export class Selectmwupurchase extends React.Component {
  constructor(props){
    super(props);

    let mwuPrice = 45 + (5 * this.props.entities[0].round);

    this.state = {
      selected: false,
      pricePerMwu: 50,
      selectedPricePerMwu: mwuPrice,
      noMwu: 1,
      maxMwu: 1,
      totalPrice: 0,
      finances: 0,
      mwuSources: [],
      selectedSource: "default"
    };
    this.handleEntitySelect = this.handleEntitySelect.bind(this);
    this.handlePriceChange = this.handlePriceChange.bind(this);
    this.handlePurchase = this.handlePurchase.bind(this);
    this.handleSourceSelect = this.handleSourceSelect.bind(this);
    this.handleAmountChange = this.handleAmountChange.bind(this);
    this.loadEntityOptions = this.loadEntityOptions.bind(this);
  }

  createAlert = (msg) => {
    this.props.createAlert(msg);
  }

  handlePurchase(e){
    e.preventDefault();
    if(this.state.selected !== false) {
      let selectedService;

      selectedService = this.state.selectedSource.name;

      const dataForCallback = {
        entityToBuyFrom: this.props.entities[this.state.selected],
        pricePerMwu: this.state.selectedPricePerMwu,
        mwu: this.state.noMwu,
        service: selectedService,
        marketPrice: this.state.selectedPricePerMwu,
        type: "mwu",
      };
      this.props.callbackPurchase(dataForCallback);
    }
  }

  handleEntitySelect(e) {
    const index = e.target.value;
    if( !isNaN(parseInt(index, 10)) ){
      this.setState({
        selected: index,
        mwuSources: [],
      });

      document.getElementById("select02").selectedIndex = 0;

      this.loadEntityServices(index);
    } else {
      this.setState({
        selected: false,
        mwuSources: [],
      });
    }
  }

  loadEntityServices(index) {
    const entity = this.props.entities[index];
    const entityPlants = entity.getOwnedServices();

    let powerPlants = [];

    powerPlants.push(<option  key="pl_-1" defaultValue>Selecteer een centrale om van te kopen</option>);

    for (var i = 0; i < entityPlants.length; i++) {
      // eslint-disable-next-line
      let soldMwu = parseInt(entity.soldMwu.filter((current) => {
        return current.name === entityPlants[i].name;
      }).reduce((total, current) => {
        return total + parseInt(current.mwu, 10);
      }, 0), 10);


      let maxMwu = entityPlants[i].mwu;
      if(typeof(entityPlants[i].purchasedBy) !== "string"){
        maxMwu = maxMwu / 2;
      }

      maxMwu = maxMwu - soldMwu;


      powerPlants.push(<option value={entityPlants[i].id} key={"pl_"+i}>{entityPlants[i].name + " | Max: " + maxMwu + " Mwu"}</option>);
    }

    this.setState({
      selected: index,
      mwuSources: powerPlants,
    });
  }

  handlePriceChange(net) {
    const newPrice = net;
    if ( newPrice < 5 ) {
      this.createAlert("Prijs is te laag, de minimale prijs per MWU is \u20AC5");
    } else {
      this.setState({
        selectedPricePerMwu: newPrice
      });
      this.calculateTotal("price", newPrice);
    }
  }

  handleAmountChange(num) {
    const noMwu = num;
    if ( noMwu > this.state.maxMwu ) {
      this.createAlert("Te veel stroom! Het maximale aantal MWU dat deze speler kan verkopen is " + this.state.maxMwu + "MWU.");
    } else if ( noMwu < 1 ) {
      this.createAlert("Om een deal te sluiten moet er minimaal 1 MWU worden verkocht.");
    } else {
      this.setState({
        noMwu: num
      });
    }
    this.calculateTotal("mwu", noMwu);
  }

  calculateTotal(key, val){
    let price;
    let mwu;
    if(key === "mwu"){
      mwu = val;
      price = parseInt(this.state.selectedPricePerMwu, 10);
    } else {
      price = val;
      mwu = parseInt(this.state.noMwu, 10);
    }
      let finances = 0;

    // FIXME:
    // FIXME: REALFIXME
    setTimeout(() => {
      const entity = this.props.entities[this.state.selected];

      if (!entity) { return }

      finances = entity.getApplicableTaxes(this.state.selectedSource.id, "powerPlantsBuyMwu");
      let totalPrice = 0;

      totalPrice = (mwu * price) + (mwu * finances);

      this.setState({
        totalPrice: totalPrice,
        finances: finances
      })
    },250)

  }

  handleSourceSelect(e){
    if(isNaN(parseInt(e.target.value, 10))){
      return;
    } else {
      let selectedSource;

      // selectedSource = this.props.entities[this.state.selected].getOwnedServices()[e.target.value];
      selectedSource = this.props.entities[this.state.selected].getOwnedServices().find((current) => { return current.id === parseInt(e.target.value, 10)});

      let netMaxMwu = selectedSource.mwu;
      if(typeof(selectedSource.purchasedBy) === "object"){
        netMaxMwu = netMaxMwu / 2;
      }

      const soldMwu = this.props.entities[this.state.selected].soldMwu.filter((current) => { return current.name === selectedSource.name }).reduce((totMwu, sold) => { return totMwu + sold.mwu }, 0);
      netMaxMwu = netMaxMwu - soldMwu;
      
      this.setState({
        maxMwu: netMaxMwu,
        selectedSource: selectedSource,
        selectedPricePerMwu: this.state.pricePerMwu
      });

      this.calculateTotal("price", this.state.pricePerMwu);
      this.calculateTotal("mwu", this.state.noMwu);
    }
  }

  getEntitySelect = () => {
    let style = {};
    if(this.state.selected !== false) {
      const color = this.props.entities[this.state.selected].color;
      style = {
        backgroundColor: color,
        color: 'rgba(255,255,255)'
      };
    }

    return (
      <select onChange={this.handleEntitySelect} style={style}>
        {this.loadEntityOptions()}
      </select>
    )
  }

  loadEntityOptions = () => {
    let selects = [];

    selects.push(<option key="_-1" defaultValue>Selecteer een speler om van te kopen</option>);

    for (let i = 0; i < this.props.entities.length; i++){
      let current = this.props.entities[i];
      const hasNetwork = current.upgrades.filter((currentUpgrade) => {return currentUpgrade.name === "Netwerk"}).length > 0;
      if(
        current.getMwuServices() > 0
        && hasNetwork
        && this.props.hasNetwork
        && current.name !== this.props.self
      ){
        if(
          current.type === "city" ||
          current.type === "company" ||
          current.type === "supplier"
        ){

          const activeServices = current.getOwnedServices();
          const activeServiceNames = activeServices.map(x => x.name);

          const activeSold = current.soldMwu
            .filter((current) => {return activeServiceNames.includes(current.name)})
            .reduce((total, current) => {
              return total + current.mwu
            }, 0)

          const netMwuSellable = current.getOwnedServices()
            .reduce((total, current) => {
              return total + (typeof(current.purchasedBy) === "object" ? current.mwu / 2 : current.mwu);
            }, 0) - activeSold;

          let type;
          if (current.type === "city") {
            type = 'stad';
          }
          if (current.type === "company") {
            type = 'bedrijf';
          }
          if (current.type === "supplier") {
            type = 'leverancier';
          }
          selects.push(
            <option
              key={"_"+i}
              value={i}>
              {current.name} | {type} | {netMwuSellable}
            </option>
          );
        }
      }
    }
    return selects;
  };

  changeVal = (field, amount) => {
    if (field === "price") {
      const newVal = this.state.selectedPricePerMwu + amount
      this.handlePriceChange(newVal);
    } else if(field === "mwu") {
      const newVal = this.state.noMwu + amount;
      this.handleAmountChange(newVal);
    }
  }

  getMwuNecessityRow = (decrease) => {
    if(this.props.stats.mwuNecessity !== undefined){
      let number = this.props.stats.mwuNecessity;
      if(decrease !== 0){
        number = parseInt(this.props.stats.mwuNecessity.toFixed(0), 10) - decrease;
      }
      return (
        <tr>
          <td>Elektriciteitsbehoefte</td>
          <td className="value">{number}</td>
          <td>MWU</td>
        </tr>
      )
    }
  }

  getNewValue = (type, oldVal) => {
    if(type === 'prod'){
      return parseInt(this.state.noMwu, 10) + parseInt(oldVal, 10);
    } else if(type === "green") {
      if(this.state.selectedSource === "default"){
        return 0;
      }
      let object = this.props.entities.find((obj) => { return obj.name === this.props.self});

      const greenF = parseInt(oldVal, 10) / 100;
      const totalMwu = object.getMwuServices() + object.purchasedMwu.reduce((total, cur) => {return total + cur.mwu}, 0);

      const greenMwu = Math.floor(totalMwu * greenF);

      const newGreenMwu = (this.state.selectedSource !== "default" && this.state.selectedSource !== false && this.state.selectedSource.green ? greenMwu + this.state.noMwu : greenMwu);
      const newTotalMwu = totalMwu + this.state.noMwu;

      const result = (newGreenMwu / newTotalMwu) * 100;
      if(result > 100){
        return 100;
      } else if(result < 0){
        return 0;
      } else {
        return result.toFixed(0);
      }
    } else if(type === "black"){
      if(this.state.selectedSource === "default"){
        return 0;
      }
      let object = this.props.entities.find((obj) => { return obj.name === this.props.self});

      const greenF = parseInt(oldVal, 10) / 100;
      const totalMwu = object.getMwuServices() + object.purchasedMwu.reduce((total, cur) => {return total + cur.mwu}, 0);

      const greenMwu = Math.floor(totalMwu * greenF);

      const newGreenMwu = (this.state.selectedSource !== "default" && this.state.selectedSource !== false && this.state.selectedSource.green ? greenMwu + this.state.noMwu : greenMwu);
      const newTotalMwu = totalMwu + this.state.noMwu;

      const result = 100 - ((newGreenMwu / newTotalMwu) * 100);
      if(result > 100){
        return 100;
      } else if(result < 0){
        return 0;
      } else {
        return result.toFixed(0);
      }
    }
  }

  render(){
    return (
      <div>
        <div className="row">
          <div className="col col--data col--data-small">
            <table className="purchaseComparison">
              <thead>
                <tr><td colSpan="3">Oude situatie</td></tr>
              </thead>
              <tbody>
                {this.getMwuNecessityRow(0)}
                <tr>
                  <td>Elektriciteitsvoorziening</td>
                  <td className="value">{this.props.stats.mwu.toFixed(0)}</td>
                  <td>MWU</td>
                </tr>
                <tr>
                  <td>Duurzaam</td>
                  <td className="value">{this.props.stats.mwuGreen.toFixed(0)}</td>
                  <td>%</td>
                </tr>
                <tr>
                  <td>Fossiel</td>
                  <td className="value">{this.props.stats.mwuBlack.toFixed(0)}</td>
                  <td>%</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col col--data col--data-small">
            <table className="purchaseComparison">
              <thead>
                <tr><td colSpan="3">Nieuwe situatie</td></tr>
              </thead>
              <tbody>
                {this.getMwuNecessityRow(this.state.noMwu)}
                <tr>
                  <td>Elektriciteitsvoorziening</td>
                  <td className="value">{this.props.stats.mwu.toFixed(0)}</td>
                  <td>MWU</td>
                </tr>
                <tr>
                  <td>Duurzaam</td>
                  <td className="value">{this.getNewValue("green", this.props.stats.mwuGreen.toFixed(0))}</td>
                  <td>%</td>
                </tr>
                <tr>
                  <td>Fossiel</td>
                  <td className="value">{this.getNewValue("black", this.props.stats.mwuGreen.toFixed(0))}</td>
                  <td>%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="row">
          <form>
            <div className="formRow">
              <label>Koop energie van</label>
              {this.getEntitySelect()}
            </div>
            <div className="formRow">
              <label>Energiebron</label>
              <select id="select02" onChange={this.handleSourceSelect}>
                {this.state.mwuSources}
              </select>
            </div>
            <div className="formRow">
              <label>Prijs (&euro;)</label>
              <div className="formInputNum">
                <input type='text' readOnly="true" value={this.state.selectedPricePerMwu}/>
                <div onClick={() => this.changeVal("price", -5)} className="formModifier formModifier--desc"></div>
                <div onClick={() => this.changeVal("price", 5)} className="formModifier formModifier--asc"></div>
              </div>

              <label className={(this.state.finances === 0 || !this.state.finances ? "field-hidden" : "")}>Belasting (&euro;)</label>
              <div className={"formInputNum" + (this.state.finances === 0 || !this.state.finances ? " field-hidden" : "")}>
                <input type='text' value={this.state.finances}/>
              </div>
            </div>
            <div className="formRow">
              <label>Aantal MWU</label>
              <div className="formInputNum">
                <input type='text' readOnly="true" value={this.state.noMwu}/>
                <div onClick={() => this.changeVal("mwu", -1)} className="formModifier formModifier--desc"></div>
                <div onClick={() => this.changeVal("mwu", 1)} className="formModifier formModifier--asc"></div>
              </div>
            </div>
            <div className="formRow">
              <label>Kosten (&euro;)</label>
              <div className="formInputDouble">
                <input type='text' value={(this.state.selectedPricePerMwu + this.state.finances) * this.state.noMwu} readOnly="true"/>
              </div>
              <label>Budget (&euro;)</label>
              <div className="formInputDouble">
                <input type='text' value={Math.floor(this.props.funds)} readOnly="true"/>
              </div>
            </div>
            <div className="dealButton" onClick={this.handlePurchase}>
              <img alt="dealButton" src={require("../../assets/elements/Icon - deal.svg")}/>
              <div className="text">Sluit deal!</div>
            </div>
          </form>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/interactive/selectMwuPurchase.js